"use client";

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const navLinks = [
  { label: 'PLC Architecture', href: '#plc-architecture' },
  { label: 'RFQ Framework', href: '#rfq-framework' },
  { label: 'Industries', href: '#industries' },
  { label: 'Knowledge Hub', href: '#knowledge-hub' },
  { label: 'About', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'nav-scrolled' : 'bg-white'
      }`}
    >
      <div className="max-w-container mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-18">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center gap-2.5 group">
            <AppLogo size={28} />
            <span className="font-sans font-700 text-base tracking-tight text-primary">
              PLC<span className="text-secondary font-400">Costing</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks?.map((link) => (
              <a
                key={link?.label}
                href={link?.href}
                className="text-sm font-medium text-muted hover:text-primary transition-colors duration-150"
              >
                {link?.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#free-10-hours"
              className="btn-primary text-sm font-semibold px-5 py-2.5 rounded-sm"
            >
              Ask for Demo
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden p-2 text-primary"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className="w-5 flex flex-col gap-1.5">
              <span className={`block h-px bg-primary transition-all duration-200 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
              <span className={`block h-px bg-primary transition-all duration-200 ${menuOpen ? 'opacity-0' : ''}`} />
              <span className={`block h-px bg-primary transition-all duration-200 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
            </div>
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      <div className={`lg:hidden bg-white border-t border-border mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="max-w-container mx-auto px-6 py-4 flex flex-col gap-4">
          {navLinks?.map((link) => (
            <a
              key={link?.label}
              href={link?.href}
              className="text-sm font-medium text-muted hover:text-primary transition-colors py-1"
              onClick={() => setMenuOpen(false)}
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#free-10-hours"
            className="btn-primary text-sm font-semibold px-5 py-2.5 rounded-sm text-center mt-2"
            onClick={() => setMenuOpen(false)}
          >
            Ask for Demo
          </a>
        </div>
      </div>
    </header>
  );
}